module.exports = __webpack_public_path__ + "img/clinical_medicine.7dbc91f2.svg";